import {
  useNavigation,
  useCurrentArtboard,
  isScreenFlow,
  useKey,
  ARROW_LEFT,
  ARROW_RIGHT,
  PAGE_UP,
  PAGE_DOWN,
  useUndoRedo,
} from '@sketch-hq/sketch-prototype-player'
import { useMemo } from 'react'

/**
 * Keyboard shortcuts for the prototype player.
 */
export function useKeyboardShortcuts() {
  const { navigate } = useNavigation()
  const { undo, redo } = useUndoRedo()
  const currentArtboard = useCurrentArtboard()

  const flows = useMemo(
    () =>
      (currentArtboard?.layers || [])
        .map(layer => layer.flow)
        .filter(isScreenFlow),
    [currentArtboard?.layers]
  )

  const firstFlow = flows[0] || null

  useKey(ARROW_LEFT, () => {
    undo()
  })

  useKey(ARROW_RIGHT, () => {
    redo()
  })

  // The PageUp and PageDown shortcuts below are a semi "hidden" feature to
  // facilitate stepping through simple linear "presentation" style prototypes
  // with a hardware presentation clicker device. While clicking forwards it
  // simply selects the first hotspot/flow on the current Artboard and navigates
  // to its destination.

  useKey(PAGE_UP, () => {
    undo()
  })

  useKey(PAGE_DOWN, () => {
    if (firstFlow) navigate(firstFlow.id)
  })
}
